import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AnalyzesComponent } from './containers/analyzes/analyzes.component';
import { BasesComponent } from './containers/bases/bases.component';

const routes: Routes = [
 { path: '', redirectTo: 'analysis' },
  { path: 'analysis', component: AnalyzesComponent, data: { breadcrumb: 'Análises' } },
  { path: 'base', component: BasesComponent, data: { breadcrumb: 'Bases geradas' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProjectRoutingModule {}
